export default "__VITE_ASSET__gxdziBDm__"